import { compose } from 'redux';
import { connect } from 'react-redux';
import { flow, map, replace, uniqBy, upperFirst } from 'lodash/fp';
import { H2, P, PageNavigationBar, Section, Wrapper } from '@ahmdigital/ui';
import { PureComponent } from 'react';

import { ContentContainer, SectionContainer, SectionWrapper } from './styles';
import { RootState } from '../../reducers';
import AllProductsDataLoader from '../../components/all-products-data-loader';
import BackToTop from '../../elements/back-to-top';
import Banner from '../../elements/banner';
import DocIconSection from './components/doc-icon-section';
import getSaleableProductIdsKeyedByType from '../../utils/get-saleable-product-ids-keyed-by-type';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import ProductSubsection from './components/product-subsection';
import sections from './data';
import uncapFpIterator from '../../../utils/uncap-fp-iterator';

const mapWithIndex = uncapFpIterator(map);

type DownloadsPageProps = {
  products: {};
};

class DownloadsPage extends PureComponent<DownloadsPageProps> {
  // @ts-expect-error - Automatic, Please fix when editing this file
  static transformTypeName(typeName) {
    switch (typeName) {
      case 'package':
        return 'hospital-and-extras-packages';
      default:
        return `${typeName}-cover`;
    }
  }

  prepareProductData() {
    const { products } = this.props;

    // @ts-expect-error - Automatic, Please fix when editing this file
    return mapWithIndex((productIds, typeName) => {
      const typeLink = `${DownloadsPage.transformTypeName(typeName)}-guides`;

      const uniqueProductGuides = flow(
        map((productId) => {
          // @ts-expect-error - Automatic, Please fix when editing this file
          const product = products?.[productId];
          return {
            guideUrl: product?.guideUrl?.[product.type] ?? '',
            name: product.name,
          };
        }),
        uniqBy('name'),
      )(productIds);

      return {
        data: uniqueProductGuides,
        link: typeLink,
        title: flow(upperFirst, replace(/-/g, ' '))(typeLink),
      };
    }, getSaleableProductIdsKeyedByType());
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  render() {
    const { products } = this.props;

    if (!products) {
      return null;
    }

    const links = mapWithIndex(
      // @ts-expect-error - Automatic, Please fix when editing this file
      (item) => ({
        id: item.link,
        text: item.title,
      }),
      [sections.heading, ...sections.guides],
    );

    return (
      <LegacyBorderedWrapper>
        <Head>
          <title>Forms and guides</title>
          <meta
            name="description"
            content="Download claim forms, our health insurance product guides and other important ahm documents."
          />
        </Head>
        <Banner title="Forms and guides" />
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <ContentContainer id="backToTopPoint" tabIndex="-1">
          <PageNavigationBar items={links} variant="white" />
          <SectionContainer>
            <SectionWrapper id={sections.heading.link}>
              <Section variant="paddingTopSpacer4">
                <Wrapper>
                  <H2>{sections.heading.title}</H2>
                  <P looksLike="h4" variant="regular">
                    These guides summarise what you can claim, how much you’ll get back, your annual limits and when you
                    can start claiming.
                  </P>
                  <br />
                  {mapWithIndex(
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    (productTypeData, index) => (
                      <ProductSubsection key={index} {...productTypeData} />
                    ),
                    this.prepareProductData(),
                  )}
                </Wrapper>
              </Section>
            </SectionWrapper>

            {mapWithIndex(
              // @ts-expect-error - Automatic, Please fix when editing this file
              (section, index) => (
                <DocIconSection key={index} {...section} />
              ),
              sections.guides,
            )}
          </SectionContainer>
          <BackToTop />
        </ContentContainer>
      </LegacyBorderedWrapper>
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  products: state.product.data,
});

export default compose(AllProductsDataLoader, connect(mapStateToProps))(DownloadsPage);

export { DownloadsPage as DownloadsPageForTest, mapStateToProps };
